/**
 * AccountNav Theme
 * Styling configuration for Account mobile navigation swiper
 */

const baseStyle = {
  root: {
    marginBottom: 4,
    paddingX: {base: '20px'},
    paddingBottom: '1px',
    paddingTop: 4,
    position: {'base': 'relative', 'lg': 'sticky'},
    top: 0,
    zIndex: 10,
    overflow: 'hidden',
    sx: {
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '20px',
        height: '1px',
        right: '20px',
        backgroundColor: 'brandColors.greyscale10',
      },
    },
  },
  navItem: {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    color: 'brandColors.greyscale90',
    fontSize: '16px',
    fontWeight: '500',
    height: 'auto',
    minWidth: 'auto',
    transitionProperty: 'none',
    whiteSpace: 'nowrap',

    _hover: {
      backgroundColor: 'transparent',
      color: 'brandColors.greyscale90',
      textDecoration: 'underline',
      textUnderlineOffset: '21px',
      textDecorationThickness: '2px',
      textDecorationColor: 'brandColors.primaryDarkLinen',
    },

    _active: {
      backgroundColor: 'transparent',
    },

    _focus: {
      boxShadow: 'none',
    },
    sx: {
      '&': {
        paddingX: {base: 0, lg: 0},
        paddingBottom: '19px',
        paddingTop: 2,
      },
      '&:hover, &:active, &[data-active]': {
        textDecorationColor: 'brandColors.primaryDarkLinen',
      },
    },
  },
  navItemActive: {
    color: 'black',
    textDecoration: 'underline',
    textUnderlineOffset: '21px',
    textDecorationThickness: '2px',
    textDecorationColor: 'brandColors.primaryDarkLinen',
    _hover: {
      backgroundColor: 'transparent',
      color: 'brandColors.greyscale90',
      textDecoration: 'underline',
      textUnderlineOffset: '21px',
      textDecorationThickness: '2px',
      textDecorationColor: 'brandColors.primaryDarkLinen',
    },
  },
};

const AccountNav = {
  baseStyle,
  parts: ['root', 'navItem', 'navItemActive'],
};

export default AccountNav;
